import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faChartLine,
  faCheck,
  faEnvelope,
  faTimes,
  faUsers,
  faUtensils,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

// Add icons to the library
library.add(
  faUtensils, // für Ernährung/Food
  faChartLine, // für Tracking/Analytics
  faUsers, // für Community
  faCheck, // für Checkmarks
  faTimes, // für X/Close
  faEnvelope, // für Newsletter
  faBars, // für Burger Menu
  faXmark, // für Close Menu
);
